import React, { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import useDebounce from '../../hooks/useDebounce'
import useFullPageLoader from '../../hooks/useFullPageLoader'
import { Avatar, IconButton } from '@mui/material'
import Switch from '../../components/Switch/Switch'
import NotFound from '../../components/not-found/NotFound'
import Pagination from 'react-js-pagination'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { meditation, training } from '../../routes/route'
import common from '../../routes/common'
import { toastMessage } from '../../utils/toastMessage'
import findSerialNumber from '../../utils/findSerialNumber'
import { charLimit } from '../../utils/charLimit'
import EditIcon from '@mui/icons-material/Edit'
import showFullSizeImage from '../../utils/showFullSizeImage'
import scrollToUp from '../../utils/scrollToUp'
import { fetchMeditationApi } from '../../services/meditationManagement'
import { getLocalStorage, setLocalStorage } from '../../config/config'
import { fetchTrainigCategoryApi } from '../../services/trainingManagement'
import AddTrainingCategory from './AddTrainingCategory'
import TrainingCategoryStatus from './TrainingCategoryStatus'
import EditTrainingCategory from './EditTrainingCategory'
import AddIcon from '@mui/icons-material/Add';
const { NOT_FOUND } = common
const { TRAINING_DETAIL } = training

const TrainingCategoryList = () => {
  // handle all state
  const [searchParam, setSearchParam] = useSearchParams()
  let activePage = +searchParam.get('page') || 1
  // const [search, setSearch] = useState(searchParam.get('query') || '')
  // let limit = +searchParam.get('limit') || 10
  const [search, setSearch] = useState(
    getLocalStorage('trainingCategory', 'search') || ''
  )
  const debounceValue = useDebounce(search || '', 300)

  const [addTrainingModal, setAddTrainingModal] = useState(false)
  const [editTrainingModel, setEditTrainingModel] = useState(false)
  const [trainingCategoryList, setTrainingCategoryList] = useState([])
  const [total, setTotal] = useState(0)
  const [loader, showLoader, hideLoader] = useFullPageLoader()
  const [statusModal, setStatusModal] = useState(false)
  const [statusValue, setStatusValue] = useState('')
  const [statusId, setStatusId] = useState('')
  const [selectedTrainingCategoryDetail, setSelectedTrainingCategoryDetail] =
    useState(null)

  useEffect(() => {
    setLocalStorage('trainingCategory', 'search', search)
  }, [search])

  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true)
    setStatusId(id)
    setStatusValue(status)
  }

  // update training category handler
  const updateTrainingCategoryHandler = (data) => {
    setSelectedTrainingCategoryDetail(data || null)
    setEditTrainingModel(true)
  }

  //*********Handel Block********* */
  // const blockHandler = (id, status) => {
  //     setBlockModal(true);
  //     setBlockId(id);
  //     // setStatusValue(status);
  // };
  //*********Handle update********* */
  // const updateHandler = (id, enName, arName, imageUrl, categoryId) => {
  //   setUpdateModal(true)
  //   setUpdateSubCategoryData({
  //     id,
  //     enName,
  //     arName,
  //     imageUrl,
  //     categoryId,
  //   })
  // }
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set('page', event)
    setSearchParam(searchParam)
  }

  // close model

  const closeModel = () => {
    setSelectedTrainingCategoryDetail(null)
    setStatusValue('')
    setStatusId('')
    setAddTrainingModal(false)
    setStatusModal(false)
    setEditTrainingModel(false)
  }

  // //------------------listing-music-Api----------------------------------
  const fetchTrainingCategoryHandler = async () => {
    try {
      setTrainingCategoryList([])
      showLoader()
      const sendData = {
        page: activePage,
        limit: 10,
      }
      if (debounceValue) {
        sendData.page = 1
        sendData.search = search
        searchParam.delete('page')
        setSearchParam(searchParam)
      }
      const { data } = await fetchTrainigCategoryApi(sendData)
      if (data.code === 200) {
        setTrainingCategoryList(data?.result?.list || [])
        setTotal(data?.result?.total || 0)
        scrollToUp()
      } else {
        setTrainingCategoryList([])
        setTotal(0)
        toastMessage(data.message, 'error', 'trainingCategoryList')
      }
    } catch (error) {
      console.log('error', error)
    } finally {
      hideLoader()
    }
  }

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   fetchCategoryHandler(activePage, debounceValue)
  // }, [searchParam, debounceValue])
  useEffect(() => {
    if (activePage === 1) {
      searchParam.delete('page')
    }
    setSearchParam(searchParam)
    fetchTrainingCategoryHandler()
  }, [searchParam, debounceValue])
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Training Management</h4>
            <div className="block_user_button">
              <button onClick={() => setAddTrainingModal(true)}>
                <AddIcon/>Add Training
              </button>
            </div>
          </div>
          <div className="FilterBox FilterArea ">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ''}
                style={{ '--color': '#FF8989' }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">{common.SEARCH_ICON}</span>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Category Title</th>
                  <th>Total Video</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>
              <tbody>
                {trainingCategoryList.length > 0 ? (
                  trainingCategoryList.map((training, index) => {
                    return (
                      <React.Fragment key={training._id}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, 10)}</td>
                          {/* <td>{training._id || '---'}</td> */}
                          <td>{charLimit(training.title, 30) || '---'}</td>
                          <td>{Number(training.meditationMedia) || 0}</td>
                          <td>
                            <div className="action_button">
                              <Link
                                to={`${TRAINING_DETAIL}/${training.title}/${training._id}`}
                              >
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>
                              <IconButton
                                aria-label="update"
                                className="px-2 py-0"
                                onClick={() =>
                                  updateTrainingCategoryHandler(training)
                                }
                              >
                                <EditIcon className="edit_icon" />
                              </IconButton>
                              <Switch
                                checked={training.status}
                                onChange={() =>
                                  statusUpdateHandler(
                                    training._id,
                                    training.status
                                  )
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    )
                  })
                ) : (
                  <NotFound
                    cols={7}
                    msg="Training Categories not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          {total >= 10 ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={'previous'}
                  nextLabel={'next'}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={10}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}

          {/* <FloatingButton
            onClick={() => setAddModalShow(true)}
            icon={<AddIcon />}
          /> */}
        </div>
        {addTrainingModal && (
          <AddTrainingCategory
            show={addTrainingModal}
            close={closeModel}
            listing={fetchTrainingCategoryHandler}
          />
        )}
        {statusModal && (
          <TrainingCategoryStatus
            show={statusModal}
            close={closeModel}
            setListing={setTrainingCategoryList}
            status={statusValue}
            id={statusId}
          />
        )}
        {editTrainingModel && (
          <EditTrainingCategory
            show={editTrainingModel}
            close={closeModel}
            trainingCategoryDetail={selectedTrainingCategoryDetail}
            setTrainingCategoryDetail={setSelectedTrainingCategoryDetail}
            trainingListing={fetchTrainingCategoryHandler}
          />
        )}
      </div>
    </>
  )
}

export default TrainingCategoryList
